export const GET_ROLES = 'rolesEpic/GET_ROLES';
export const GET_ROLES_SUCCESS = 'rolesEpic/GET_USERS_SUCCESS';
export const GET_ROLES_ERROR = 'rolesEpic/GET_USERS_ERROR';
